import { EImportEntity } from '../importer/model';
import { importReducer } from '../importer/reducer';

export const ancillarySuppliersImport = importReducer(EImportEntity.ANCILLARY_SUPPLIERS);
